/**
 * @generated SignedSource<<97f41547f70990cdb3500d93b3f177c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
export type DeleteNodeOption_deleteFolderNodes_Mutation$variables = {
  connections: ReadonlyArray<string>;
  folderNodeIds: ReadonlyArray<string>;
};
export type DeleteNodeOption_deleteFolderNodes_Mutation$data = {
  readonly deleteFolderNodes: {
    readonly folderNodeDeletedIds: ReadonlyArray<string>;
    readonly folderNodesDeleted: ReadonlyArray<{
      readonly __typename: "Folder";
      readonly id: string;
      readonly publishState: PublishState;
    } | {
      readonly __typename: "FolderItem";
      readonly id: string;
      readonly publishState: PublishState;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }>;
  } | null;
};
export type DeleteNodeOption_deleteFolderNodes_Mutation = {
  response: DeleteNodeOption_deleteFolderNodes_Mutation$data;
  variables: DeleteNodeOption_deleteFolderNodes_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "folderNodeIds"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "folderNodeIds",
        "variableName": "folderNodeIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "folderNodeDeletedIds",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publishState",
    "storageKey": null
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Folder",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "FolderItem",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNodeOption_deleteFolderNodes_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "FilesAndFoldersDeleteFolderNodesMutationPayload",
        "kind": "LinkedField",
        "name": "deleteFolderNodes",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folderNodesDeleted",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteNodeOption_deleteFolderNodes_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "FilesAndFoldersDeleteFolderNodesMutationPayload",
        "kind": "LinkedField",
        "name": "deleteFolderNodes",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "folderNodeDeletedIds",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folderNodesDeleted",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d59ecbf35e4fac6f70f94e6ab085731f",
    "id": null,
    "metadata": {},
    "name": "DeleteNodeOption_deleteFolderNodes_Mutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNodeOption_deleteFolderNodes_Mutation(\n  $folderNodeIds: [ID!]!\n) {\n  deleteFolderNodes(input: {folderNodeIds: $folderNodeIds}) {\n    folderNodeDeletedIds\n    folderNodesDeleted {\n      __typename\n      ... on Folder {\n        id\n        publishState\n      }\n      ... on FolderItem {\n        id\n        publishState\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9585f1a2269f4a6ca811807b7ac654c2";

export default node;
